class StoreSingleton {
  #store;

  get state() {
    return this.#store.getState();
  }

  get dispatch() {
    return this.#store.dispatch;
  }

  get subscribe() {
    return this.#store.subscribe;
  }

  init(store) {
    this.#store = store;
  }
}

export const storeSingleton = new StoreSingleton();
